import { render, staticRenderFns } from "./SettingsApp.vue?vue&type=template&id=0abd8440&"
import script from "./SettingsApp.vue?vue&type=script&lang=js&"
export * from "./SettingsApp.vue?vue&type=script&lang=js&"
import style0 from "./SettingsApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports